// Localized re-exports of “distant” symbols from lib-custom
// to make paths shorter

export {
    VW2EditionsViewer as EditionsViewer,
} from "../lib-custom/editions-viewer/src/EditionsViewer";
